var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playerInitialized)?_c('video-player',{attrs:{"options":_vm.playerOptions,"playsinline":true},on:{"ready":_vm.onPlayerReady}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }